import styled from "styled-components";

export const StyledLoading = styled.section`
	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100vh;
	}
`;
